import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import SingleFormLayout from '../../../../../../../../baseComponents/Layout/SingleFormLayout'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface SupplierTradeAgreementsProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
    getData: () => Promise<void>
}

const SupplierTradeAgreements: React.FC<SupplierTradeAgreementsProps> = ({ basicData, userPermissions, getData }) => {
    const { t } = useTwinTranslation()

    const fields: FormRender<SupplierModelType> = [
        {
            cols: 2,
            title: t('generalInformation', 'Información general'),
            elements: [

                {
                    name: 'special_discount',
                    label: t('specialDiscount', 'Descuento especial'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    type: 'text',
                },
                {
                    name: 'financing',
                    label: t('financing', 'Financiación'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    type: 'text'
                },
                {
                    name: 'unit_discount',
                    label: t('unitDiscount', 'Descuento unitario'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    type: 'text'
                },
                {
                    name: 'unit_margin',
                    label: t('unitMargin', 'Margen unitario'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    type: 'text'
                },
                {
                    name: 'weight_discount',
                    label: t('weightDiscount', 'Descuento por peso'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    type: 'text'
                },
                {
                    name: 'weight_margin',
                    label: t('weightMargin', 'Margen por peso'),
                    component: 'InputNumberWithLabelMarginStateFull',
                    type: 'text'
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                }
            ]
        },

    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)

    return (
        <SingleFormLayout action='/api/app/supplier/updateSupplier' onSubmit={getData} imagepath={['supplier', String(basicData?.id)]} userPermissions={userPermissions} sections={parsedFields} />
    )
}


export default SupplierTradeAgreements